import { render, staticRenderFns } from "./OktaEmailVerify.vue?vue&type=template&id=b5a4771e"
import script from "./OktaEmailVerify.vue?vue&type=script&lang=ts"
export * from "./OktaEmailVerify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports